import {Component, input, InputSignal} from '@angular/core';
import {IHairdresser} from '../../../../shared/interfaces/hairdresser.interface';
import {NgOptimizedImage, DecimalPipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {AVATAR_PLACEHOLDER} from '../../../../shared/constants/app.constants';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'braidsbook-hairdresser-map-details',
  imports: [
    NgOptimizedImage,
    RouterLink,
    DecimalPipe,
    TranslatePipe
  ],
  template: `
    @if (hairdresser()) {
      <a [title]="hairdresser()!.username" [routerLink]="['/hairdressers', hairdresser()!.username]" class="block">
        <div class="rounded-xl border-2 border-primary overflow-hidden">
          <div class="relative flex h-32">
            <img [ngSrc]="hairdresser()!.pp_link || AVATAR_PLACEHOLDER"
                 [alt]="hairdresser()!.firstname" loading="lazy" fill class="object-cover w-full h-full">
          </div>
          @if (isCalculatingRoute()) {
            <div class="p-3 bg-white">
              <div class="flex items-center gap-2 text-sm text-gray-700">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-red-500"></div>
                <span class="font-semibold text-gray-600">{{ 'MAP.CALCULATING_ROUTE' | translate }}</span>
              </div>
            </div>
          } @else if (distance() !== null) {
            <div class="p-3 bg-white">
              <div class="flex items-center gap-2 text-sm text-gray-700">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span class="font-semibold">{{ distance()! | number:'1.1-1' }} km</span>
              </div>
            </div>
          }
        </div>
      </a>
    }
  `
})
export class HairdresserMapDetailsComponent {
  hairdresser: InputSignal<IHairdresser | null> = input<IHairdresser | null>(null);
  distance: InputSignal<number | null> = input<number | null>(null);
  isCalculatingRoute: InputSignal<boolean> = input<boolean>(false);
  protected readonly AVATAR_PLACEHOLDER: string = AVATAR_PLACEHOLDER;
}
